export default __webpack_public_path__ + "static/saaslogo-3427a2e0ffb56dbdcd31cb07a6ca565c.svg";